import * as React from 'react'
import { Col } from 'react-bootstrap'
import Location from '../../adLocations/Location'
import { Variation } from '../articlesContainer'
import VariationPanel from './VariationPanel'
import { AiVariationSuggestions } from './manageAiVariationsButton/aiVariationTypes'
import { AdFormats } from '../../adFormat/adFormat'

interface VariationContainerProps {
	articleUid: string
	variation: Variation
	updateVariationField?: (
		uid: string,
		variationNum: number,
		prop: keyof Variation,
		value: any,
		instant?: boolean,
	) => void
	duplicateVariation?: (articleUid: string, variationNo: number, instant?: boolean) => void
	removeVariation?: (articleUid: string, variationNo: number, instant?: boolean) => void
	selectedLocations?: Location[]
	campaignIsActive?: boolean
	instant?: boolean
	client?: {
		id: number
		org: string
	}
	campaignId?: number
	articleId?: number
	managingAiSuggestions?: boolean
	approveOrDisapproveAiSuggestion?: (variation: Variation, approve: boolean) => void
	allSuggestions?: AiVariationSuggestions
	adFormat: AdFormats
	readonly?: boolean
}

interface VariationContainerState {
	showModal: boolean
	modalName: string
	modalTitle: string
}

class VariationContainer extends React.Component<VariationContainerProps, VariationContainerState> {
	constructor(props: VariationContainerProps) {
		super(props)

		this.state = {
			showModal: false,
			modalName: '',
			modalTitle: '',
		}
	}

	public shouldComponentUpdate(nextProps: VariationContainerProps, nextState: VariationContainerState) {
		if (
			JSON.stringify(this.props.variation) !== JSON.stringify(nextProps.variation) ||
			JSON.stringify(this.props.allSuggestions) !== JSON.stringify(nextProps.allSuggestions) ||
			(this.props.selectedLocations && this.props.selectedLocations.length) !==
				(nextProps.selectedLocations && nextProps.selectedLocations.length)
		) {
			return true
		}
		if (
			this.state.showModal !== nextState.showModal ||
			this.state.modalName !== nextState.modalName ||
			this.state.modalTitle !== nextState.modalTitle
		) {
			return true
		}
		return false
	}

	private handleCloseModal = () => {
		this.setState({
			modalName: '',
			modalTitle: '',
			showModal: false,
		})
	}
	private handleShowModal = (modal: string) => {
		const modalTitle =
			modal === 'ClickTargetModal'
				? 'Click Target URL'
				: modal === 'ImpressionPixelModal'
				? 'Impression Tracking Pixel URL(s) (optional)'
				: ''
		this.setState({
			showModal: true,
			modalName: modal,
			modalTitle,
		})
	}

	public render() {
		return (
			<Col sm={6} lg={this.props.managingAiSuggestions ? 3 : 4} style={{ marginBottom: '10px' }}>
				<VariationPanel
					showModal={this.state.showModal || this.props.variation.suggestion}
					modalName={this.state.modalName}
					modalTitle={this.state.modalTitle}
					articleUid={this.props.articleUid}
					articleId={this.props.articleId}
					variation={this.props.variation}
					updateVariationField={this.props.updateVariationField}
					handleCloseModal={this.handleCloseModal}
					handleShowModal={this.handleShowModal}
					duplicateVariation={this.props.duplicateVariation}
					removeVariation={this.props.removeVariation}
					selectedLocations={this.props.selectedLocations}
					campaignIsActive={this.props.campaignIsActive}
					instant={this.props.instant}
					client={this.props.client}
					campaignId={this.props.campaignId}
					managingAiSuggestions={this.props.managingAiSuggestions}
					approveOrDisapproveAiSuggestion={this.props.approveOrDisapproveAiSuggestion}
					allSuggestions={this.props.allSuggestions}
					adFormat={this.props.adFormat}
					readonly={this.props.readonly}
				/>
			</Col>
		)
	}
}

export default VariationContainer
